<template>
  <div class="time-picker-wrapper">
    <p class="label">Time interval:</p>
    <div class="top-bar-filter-padding">
      <vue-timepicker format="HH:mm" v-model="time_start" hide-clear-button />
      <span class="text-blue-styled">- </span>
      <vue-timepicker format="HH:mm" v-model="time_end" hide-clear-button />
      <button class="btn" v-if="time_start.HH && time_start.mm && time_end.HH && time_end.mm"
        @click="$emit('selectTime', {time_start, time_end})">
        Ok
      </button>
    </div>
  </div>
</template>

<script>
  import VueTimepicker from '@/components/VueTimepickerCustom';

  export default {
    name: 'TimeFilter',
    components: { VueTimepicker },
    props: {
      start: {},
      end: {},
    },
    data() {
      return {
        'time_start': { HH: '', mm: '' },
        'time_end': { HH: '', mm: '' },
      };
    },
    watch: {
      start(newValue) {
        this.time_start = newValue;
      },
      end(newValue) {
        this.time_end = newValue;
      }
    }
  }
</script>

<style scoped>
  .time-picker-wrapper {
    width: 100%;
    height: 7vh;
    display: flex;
    align-items: center;
  }

  @media (max-width: 1270px) {
    .time-picker-wrapper {
      height: auto;
      /* margin-top: 5px; */
    }

    .time-picker-wrapper p {
      margin-bottom: 0;
    }
  }
</style>

